import {createAction} from 'redux-actions';

//action types
const SAGA_RELOAD_DATA = "DBM/DATA/SAGA_RELOAD_DATA";
//const SAGA_RELOAD_DATA_CURRENCY_PAIR = "DBM/DATA/SAGA_RELOAD_DATA_CURRENCY_PAIR";

const sagaReloadData = createAction(SAGA_RELOAD_DATA);
//const sagaReloadDataCurrencyPair = createAction(SAGA_RELOAD_DATA_CURRENCY_PAIR);


export const actionTypes = {
    SAGA_RELOAD_DATA
    //SAGA_RELOAD_DATA_CURRENCY_PAIR
};

export const actions = {
    sagaReloadData
    //sagaReloadDataCurrencyPair
};
